import React, { useEffect } from 'react';
import Img from 'gatsby-image';
import PropTypes from "prop-types";
import { Link } from 'gatsby';
import { slugify, getVenueInfo } from '../utils/utils';
import '../styles/venue-box.scss';
import ImageCarousel from './image-carousel';

function VenueBox({ data }) {
  return (
    <Link to={'/venues/' + slugify(data.title)} className={`venue-box`}>
      <div className='venue-box__img-harness'>
        <ImageCarousel images={[data.imageSlider[0]]} />
      </div>
      <div className='venue-box__inner'>
        <div>
          <div className='venue-box__title'>{data.title}</div>
          <div className='venue-box__info'>{getVenueInfo(data)}</div>
        </div>
      </div>
    </Link>
  )
}

VenueBox.propTypes = {
  data: PropTypes.object
};

VenueBox.defaultProps = {
  data: null
};

export default VenueBox;
